import React from 'react';
import {
  FDIcon, FDPaper, FDStack, FDTitleText,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const GoalItemLayout = ({ index, resourceGroup }) => {
  return (
    <FDPaper width={'100%'}>
      <FDStack direction={'row'} spacing={2} width={'100%'} alignItems={'center'} paddingX={4} paddingY={3}>
        <FDTitleText size={'lg'} value={index + 1} color={'textSecondary'} />
        <FDIcon size={'sm'} color={'textSecondary'} icon={'dragIndicator'} />
        <FDStack direction={'column'} spacing={2} alignItems={'center'}>
          {resourceGroup.map(res => <FDTitleText key={res.id()} size={'lg'} color={'textSecondary'} value={res.attr('name')} />)}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

GoalItemLayout.propTypes = {
  index: PropTypes.number.isRequired,
};

export { GoalItemLayout };
